import type { CollectionKind } from "~/utils/collectionKind"
import { FASHION_ADJUSTMENT_QUESTIONS, type FramingQuestionId } from "~/utils/demandFraming"

/**
 * The NOOS Insights card's questions, in display order: fashion's plus phasing out. `discounts` is
 * shown but not answerable (`NOOS_DISCOUNTS_PENDING`), so it is not counted.
 */
export const NOOS_ADJUSTMENT_QUESTIONS: readonly FramingQuestionId[] = [
  "preorderDevelopment",
  "stockout",
  "phasingOut",
]

/**
 * Why NOOS discounts are shown but not answerable: the discount a NOOS plan normalises to is still
 * undecided. The router refuses the write with the same words the picker shows.
 */
export const NOOS_DISCOUNTS_PENDING =
  "Discounts on NOOS can't be answered yet. We're still deciding which discount level to plan from."

/**
 * Why `question` can't be answered on this kind, or undefined where it can. The picker shows it, the
 * router refuses the write with it and the engine resolves the question to its default.
 */
export const lockedQuestionReason = (
  kind: CollectionKind,
  question: FramingQuestionId,
): string | undefined =>
  kind === "noos" && question === "discounts" ? NOOS_DISCOUNTS_PENDING : undefined

export const adjustmentQuestionsFor = (kind: CollectionKind): readonly FramingQuestionId[] =>
  kind === "fashion" ? FASHION_ADJUSTMENT_QUESTIONS : NOOS_ADJUSTMENT_QUESTIONS
